import { DataType, type IGroupShapeData, type IShapeData, type ISmartArtData } from '../../data';
import type { IShapeNonVisualPropsData } from '../../data';
import type { ICTShapeMsDsp, ICTShapeNonVisualMsDsp } from '@tencent/slide-sdk-pb-model';

export class DiagramGroupShapeUtils {
    // smartart转组合
    public static convertSmartArtToIGroupShapeData(data: ISmartArtData): IGroupShapeData {
        const { diagram } = data;
        const groupShapeData: IGroupShapeData = {
            ...(({ diagram, ...rest }) => rest)(data),
            type: DataType.GroupShape,
            // 丢弃了diagram?.drawing?.spTree下的nvGrpSpPr与grpSpPr
            shapeList:
                diagram?.drawing?.spTree?.egGroupShapeMsDsp?.map((item) => {
                    // 假设这里需要将item转换为IDrawingShapeData类型
                    if (item?.sp) {
                        return DiagramShapeUtils.toShape(item?.sp);
                    }
                    // 如果item?.sp不存在，则抛出错误
                    throw new Error("Invalid item: 'sp' property is missing.");
                }) || [],
        };
        return groupShapeData;
    }
}

export class DiagramShapeUtils {
    // 将IShapeData转换为ICTShapeMsDspz类型
    public static fromShape(shape: IShapeData): ICTShapeMsDsp {
        const { nvPr, spPr, style, txBody, txXfrm, modelId } = shape;
        const nvSpPr: ICTShapeNonVisualMsDsp = {
            cNvPr: {
                hlinkClick: nvPr.hlinkClick,
                hlinkHover: nvPr.hlinkHover,
                name: nvPr.name,
                descr: nvPr.descr,
                hidden: nvPr.hidden,
                title: nvPr.title,
            },
            cNvSpPr: {
                spLocks: nvPr.locking,
                txBox: nvPr.txBox,
            },
        };
        return {
            nvSpPr,
            spPr,
            style,
            txBody,
            txXfrm,
            modelId,
        };
    }

    // 将ICTShapeMsDspz转换为IShapeData类型
    public static toShape(msDsp: ICTShapeMsDsp): IShapeData {
        const { nvSpPr, spPr, style, txBody, txXfrm, modelId } = msDsp;
        const nvPr: IShapeNonVisualPropsData = {
            hlinkClick: nvSpPr?.cNvPr?.hlinkClick,
            hlinkHover: nvSpPr?.cNvPr?.hlinkHover,
            name: nvSpPr?.cNvPr?.name,
            descr: nvSpPr?.cNvPr?.descr,
            hidden: nvSpPr?.cNvPr?.hidden,
            title: nvSpPr?.cNvPr?.title,
            locking: nvSpPr?.cNvSpPr?.spLocks,
            txBox: nvSpPr?.cNvSpPr?.txBox,
        };
        return {
            type: DataType.Shape,
            id: modelId || '',
            nvPr,
            spPr: spPr || {},
            style,
            txBody,
            txXfrm,
            modelId,
        };
    }
}
